import React from "react";
import ReactPlayer from "react-player";
import styled from "styled-components";
import { Flex, Typography } from "antd";
import { PlayCircleOutlined, PauseCircleOutlined } from "@ant-design/icons";

const Frame = styled.button`
	position: relative;
	background: transparent;
	border: none;
	outline: none;
	cursor: pointer;
	.controls-container {
		display: ${({ playing }) => (playing ? "none" : "block")};
	}
	&:hover {
		.controls-container {
			display: block;
		}
	}
`;

const Controls = styled.div`
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	.ant-typography {
		font-size: 24px;
	}
`;

export default function VideoPlayer({ vertical, ...props }) {
	const videoRef = React.useRef(null);

	const [playing, setPlaying] = React.useState(false);

	const handlePlayPause = () => {
		setPlaying((prev) => !prev);
	};

	const Icon = playing ? PauseCircleOutlined : PlayCircleOutlined;
	return (
		<Frame playing={playing} onClick={handlePlayPause}>
			<ReactPlayer {...props} ref={videoRef} playing={playing} />
			<Controls className="controls-container" playing={playing}>
				<Flex gap={16} vertical={vertical} justify="center" align="center" className="video-controls">
					<Typography.Text style={{ color: "#fff" }}>{playing || vertical ? "" : "Watch Video"}</Typography.Text>
					<Icon style={{ color: "#fff", fontSize: 32 }} />
				</Flex>
			</Controls>
		</Frame>
	);
}

